const handleBlob = async blobFile => {
  return new Promise((res, rej) => {
    // eslint-disable-next-line no-undef
    const csvReader = new FileReader();
    csvReader.onload = () => res(csvReader.result);
    csvReader.onerror = () => rej(csvReader.error);
    csvReader.readAsText(blobFile);
  });
};

export default handleBlob;
